<template>
  <section v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); 
  `"
  >
    <div class="container tw-grid tw-w-full tw-grid-cols-12 tw-gap-y-12 lg:tw-gap-x-12">
      <div
        class="tw-col-span-12"
        :class="{
          'lg:tw-col-span-7 xl:tw-col-span-8': sidebarComponents && sidebarComponents.length > 0,
        }"
      >
        <div v-if="vars.isSearchBoxEnabledBool" class="blogs-page tw-mb-10 tw-w-full">
          <h3 v-if="!vars.showTotalBlogNumberBool" class="tw-mb-10">SEARCH</h3>
          <h3 v-else class="tw-mb-10"><span class="n-title-secondary">{{ total }}</span> Blogs</h3>
          <search-box
            v-model="keyword"
            :search-result-list="[]"
            :placeholder="searchBoxPlaceholder"
            :search-method="onSearched"
            version="v2"
          />
        </div>

        <div v-if="isBlogsLoading" style="height: 60dvh">
          <loader :loader-color="colors.brown" />
        </div>
        <div v-else-if="blogs && blogs.length === 0">
          <lazy-library-not-found :title="notFound.title" :description="notFound.description" />
        </div>

        <div v-else-if="!isBlogsLoading" class="tw-grid tw-grid-cols-12 tw-gap-x-6 tw-gap-y-10 xl:tw-gap-x-10">
          <div
            v-for="(blog, index) in blogs"
            :key="`blog-${index}`"
            class="tw-col-span-12"
            :class="{
              'md:tw-col-span-6 lg:tw-col-span-12 xl:tw-col-span-6': sidebarComponents && sidebarComponents.length > 0,
              'md:tw-col-span-6 lg:tw-col-span-4': !sidebarComponents || sidebarComponents.length === 0,
            }"
          >
            <lazy-theme7-blogs-blog-card :blog="blog" :index="index" :component="component" :version="vars.cardVersionText || 'v2'" />
          </div>
        </div>
        <div v-if="isPaginationVisible">
          <lazy-library-blogs-pagination
            :component="component"
            version="v3"
            pagination-active-bg="var(--c-primary);"
            pagination-bg="transparent"
          />
        </div>
        <div
          v-if="!vars.isPaginationEnabledBool"
          class="tw-flex tw-w-full tw-items-center tw-justify-center tw-pt-10 lg:tw-pt-20"
        >
          <nuxt-link class="n-primary outlined" :to="ROUTES.BLOGS" :external="true">LOAD MORE</nuxt-link>
        </div>
      </div>
      <div
        v-if="sidebarComponents && sidebarComponents.length > 0"
        class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4"
      >
        <div class="sidebar tw-flex tw-flex-col tw-gap-6">
          <theme7-available-components-for-sidebar
            key="blogs-page-sidebar"
            key-prefix="blogs-page-sidebar"
            :specific-components="sidebarComponents"
          />
        </div>
      </div>
    </div>
  </section>

  <section v-if="variants.v2 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); 
  `"
  >
    <div class="container tw-grid tw-w-full tw-grid-cols-12 tw-gap-y-12 lg:tw-gap-x-12">
      <div
        class="tw-col-span-12"
        :class="{
          'lg:tw-col-span-7 xl:tw-col-span-8': sidebarComponents && sidebarComponents.length > 0,
        }"
      >
        <div v-if="vars.isSearchBoxEnabledBool" class="blogs-page tw-mb-10 tw-w-full">
          <h3 v-if="!vars.showTotalBlogNumberBool" class="tw-mb-10">SEARCH</h3>
          <h3 v-else class="tw-mb-10"><span class="n-title-secondary">{{ total }}</span> Blogs</h3>
          <search-box
            v-model="keyword"
            :search-result-list="[]"
            :placeholder="searchBoxPlaceholder"
            :search-method="onSearched"
            version="v2"
          />
        </div>

        <div v-if="isBlogsLoading" style="height: 60dvh">
          <loader :loader-color="colors.brown" />
        </div>
        <div v-else-if="blogs && blogs.length === 0">
          <lazy-library-not-found :title="notFound.title" :description="notFound.description" />
        </div>

        <div v-else-if="!isBlogsLoading" class="tw-grid tw-grid-cols-12 tw-gap-x-6 tw-gap-y-10 xl:tw-gap-x-10">
          <div
            v-for="(blog, index) in blogs"
            :key="`blog-${index}`"
            class="tw-col-span-12"
            :class="{
              'md:tw-col-span-6 lg:tw-col-span-12 xl:tw-col-span-6': sidebarComponents && sidebarComponents.length > 0,
              'md:tw-col-span-6 lg:tw-col-span-4': !sidebarComponents || sidebarComponents.length === 0,
            }"
          >
            <lazy-theme7-blogs-blog-card :blog="blog" :index="index" :component="component" :version="String(vars.cardVersionText) || 'v2'" :variables="vars" />
          </div>
        </div>
        <div v-if="isPaginationVisible">
          <lazy-library-blogs-pagination
            :component="component"
            version="v5"
            pagination-active-bg="var(--c-primary);"
            pagination-bg="transparent"
          />
        </div>
        <div
          v-if="!vars.isPaginationEnabledBool"
          class="tw-flex tw-w-full tw-items-center tw-justify-center tw-pt-10 lg:tw-pt-20"
        >
          <nuxt-link class="n-primary outlined" :to="ROUTES.BLOGS" :external="true">LOAD MORE</nuxt-link>
        </div>
      </div>
      <div
        v-if="sidebarComponents && sidebarComponents.length > 0"
        class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4"
      >
        <div class="sidebar tw-flex tw-flex-col tw-gap-6">
          <theme7-available-components-for-sidebar
            key="blogs-page-sidebar"
            key-prefix="blogs-page-sidebar"
            :specific-components="sidebarComponents"
          />
        </div>
      </div>
    </div>
  </section>

  <section v-if="variants.v3 === variant"
    class=" layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); 
  `"
  >
    <!-- Search Section - Full Width -->
    <div v-if="vars.isSearchBoxEnabledBool" class="blogs-page tw-mb-10 tw-w-full">
      <div class="tw-relative tw-isolate">
        <!-- full-bleed bg -->
        <div
          class="tw-absolute tw-inset-0 -tw-z-10 tw-left-1/2 tw-right-1/2 -tw-ml-[50vw] -tw-mr-[50vw] tw-bg-[#2B301D] tw-overflow-hidden"
          aria-hidden="true"
        >
          <!-- watermark sadece container içinde kalsın -->
          <div class="container tw-relative tw-h-full tw-overflow-hidden">
            <BlockSymbol
              v-if="vars.watermarkImage"
              :block-logo-image="String(vars.watermarkImage)"
              :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
              position-text="right_bottom"
              :company-key="company.company_key"
              image-class="wm-size"
            />
          </div>
        </div>

        <!-- içerik -->
        <div class="container tw-py-10 md:tw-py-14">
          <h2 v-if="!vars.showTotalBlogNumberBool" class="tw-mb-10 tw-text-white">Search</h2>
          <h3 v-else class="tw-mb-10 tw-text-white"><span class="n-title-secondary">{{ total }}</span> Blogs</h3>

          <search-box
            v-model="keyword"
            :search-result-list="[]"
            :placeholder="searchBoxPlaceholder"
            :search-method="onSearched"
            version="v4"
          />
        </div>
      </div>
    </div>

    <!-- Content Section - Blog Cards and Sidebar -->
    <div class="container tw-grid tw-w-full tw-grid-cols-12 tw-gap-y-12 lg:tw-gap-x-12">
      <div
        class="tw-col-span-12"
        :class="{
          'lg:tw-col-span-7 xl:tw-col-span-8': sidebarComponents && sidebarComponents.length > 0,
        }"
      >
        <div v-if="isBlogsLoading" style="height: 60dvh">
          <loader :loader-color="colors.brown" />
        </div>
        <div v-else-if="blogs && blogs.length === 0">
          <lazy-library-not-found :title="notFound.title" :description="notFound.description" />
        </div>

        <div v-else-if="!isBlogsLoading" class="tw-grid tw-grid-cols-12 tw-gap-x-6 tw-gap-y-10 xl:tw-gap-x-10">
          <div
            v-for="(blog, index) in blogs"
            :key="`blog-${index}`"
            class="tw-col-span-12"
            :class="{
              'md:tw-col-span-6 lg:tw-col-span-12 xl:tw-col-span-6': sidebarComponents && sidebarComponents.length > 0,
              'md:tw-col-span-6 lg:tw-col-span-4': !sidebarComponents || sidebarComponents.length === 0,
            }"
          >
            <lazy-theme7-blogs-blog-card :blog="blog" :index="index" :component="component" :version="String(vars.cardVersionText) || 'v6'" :variables="vars" />
          </div>
        </div>
        <div v-if="isPaginationVisible">
          <lazy-library-blogs-pagination
            :component="component"
            version="v6"
            pagination-active-bg="var(--c-primary);"
            pagination-bg="transparent"
          />
        </div>
        <div
          v-if="!vars.isPaginationEnabledBool"
          class="tw-flex tw-w-full tw-items-center tw-justify-center tw-pt-10 lg:tw-pt-20"
        >
          <nuxt-link class="n-primary outlined" :to="ROUTES.BLOGS" :external="true">LOAD MORE</nuxt-link>
        </div>
      </div>
      <div
        v-if="sidebarComponents && sidebarComponents.length > 0"
        class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4"
      >
        <div class="sidebar tw-flex tw-flex-col tw-gap-6">
          <theme7-available-components-for-sidebar
            key="blogs-page-sidebar"
            key-prefix="blogs-page-sidebar"
            :specific-components="sidebarComponents"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import Loader from '~/components/common/Loader.vue';
import NotFound from '~/components/theme4/base/NotFound.vue';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import NcButton from '~/components/common/inputs/NcButton.vue';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import SearchBox from '~/components/common/SearchBox.vue';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'Theme7BlogsPage',
  components: { SearchBox, NcButton, NotFound, Loader , BlockSymbol },

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  computed: {
    ...mapState(useWebsiteStore, ['theme', 'sidebarComponents']),

    isLatestCarouselEnabled() {
      return this.vars.isLatestCarouselEnabledNumber;
    },

    isLatestCarouselVisible() {
      const route = useRoute();
      return this.isLatestCarouselEnabled && this.blogs.length !== 0 && !route.query.q && !route.query.page;
    },

    isPaginationEnabled() {
      return this.vars.isPaginationEnabledBool;
    },

    isPaginationVisible() {
      return this.isPaginationEnabled && !this.isBlogsLoading;
    },

    variant() {
      return useVariant(this.component);
    },

    backgroundColor() {
      return getVariable(this.component, 'background-color');
    },

    titleHtml() {
      return this.vars.titleHtml;
    },

    ROUTES() {
      return ROUTES;
    },

    is() {
      return defineAsyncComponent(
        /* TODO: ~ didn't work when I used it. */
        () => import(`../AvailableComponentsForSidebar.vue`),
      );
    },
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      keyword: '',
      searchBoxPlaceholder: 'Search',
    };
  },

  mounted() {
    const route = useRoute();
    // TODO: Check where we are in blogs list or not
    if (route.query.q) {
      this.keyword = route.query.q as string;
    }
  },

  methods: {
    async onSearched() {
      const blogsStore = useBlogsStore();
      await blogsStore.searchBlogs(this.keyword);
    },
  },

  watch: {
    async $route(a, b) {
      if (a.query.q !== b.query.q) {
        await fetchBlogsManager(this.component, a.query && a.query.q ? a.query.q : null);
      }
    },
  },
});
</script>
<style scoped>
.sec {
  position: relative;
  overflow: hidden;
}

:deep(.wm-size) {
  width: clamp(1000px, 50vw, 1200px) !important;
  height: auto !important;
}
/* component <style scoped> içinde */
:deep(.wm-size) {
  width: clamp(1000px, 50vw, 1200px) !important; 
  height: auto !important;
}

@media (max-width: 768px) {
  :deep(.wm-size) {
    width: 800px !important;         
         /* güvence */
    height: 250px !important;
    position: relative !important;   
    top: -10px !important;           
    right: -15px !important;         
  }
}




</style>
